import checkIconFallback from '../assets/icons/check.svg';
import { BRAND_LOGOS, BRANDS_ROWS } from '../data/brands';
import { COLLABORATIONS_MAIN_SECTIONS } from '../data/collaborationsMain';
import { HOW_WE_COLLABORATE_ITEMS } from '../data/howWeCollaborate';
import { WHY_IT_ITEMS } from '../data/whyIt';
import { resolveMediaUrl } from './mediaUrl';

export const WHAT_WE_OFFER_FALLBACK = {
  eyebrow: 'What We Offer',
  title: 'Comprehensive Solutions from Seed to Scale',
  description:
    'Tailored services designed to optimize every facet of your automotive business, from market entry to sustainable growth.',
};

export const SUCCESS_STORY_FALLBACK = {
  eyebrow: 'Success Stories',
  title: 'Delivering Industry-Leading Excellence',
  description:
    'Explore how we turn complex operational requirements into state-of-the-art automotive facilities and successful distributorships.',
};

export const BLOGS_SECTION_FALLBACK = {
  eyebrow: 'Market Intelligence',
  title: 'Latest Trends & Strategic Insights',
  description:
    'Stay ahead of the competition with our regular updates on market shifts, competitor strategies, and customer behavior across the region.',
};

export const NAVBAR_FALLBACK = {
  about: 'About us',
  services: 'Services',
  coreModels: 'Core models',
  projects: 'Projects',
  collaborations: 'Key collaborations',
  contact: 'Contact',
  openMenu: 'Open menu',
  closeMenu: 'Close menu',
  aboutTo: '/about',
  servicesTo: '/services',
  coreModelsTo: '/coremodels',
  projectsTo: '/projects',
  collaborationsTo: '/collaborations',
  contactTo: '/contact',
  servicesHasSubmenu: true,
  logoAlt: 'Tevris',
};

/** Services listing page — all-services section header (same CMS key, different defaults). */
export const SERVICES_WHAT_WE_OFFER_FALLBACK = {
  eyebrow: 'What We Offer',
  title: 'Comprehensive Services Across the Automotive Value Chain',
  description:
    'Each service is designed to address a specific stage of your business journey, from setup to scale.',
};

export const ADVANTAGE_FALLBACK = {
  eyebrow: 'The Tevris Advantage',
  title: 'Trusted by leading automotive brands in Iraq',
  description:
    'Our core values define how we work with our partners to ensure long-term value creation and operational success in the region.',
  items: [
    {
      title: 'Local Expertise',
      description: "Deep understanding of Iraq's automotive market dynamics",
      iconUrl: '',
    },
    {
      title: 'Proven Track Record',
      description: 'Trusted by leading global automotive brands',
      iconUrl: '',
    },
    {
      title: 'End-to-End Solutions',
      description: 'From market entry to full operational setup',
      iconUrl: '',
    },
    {
      title: 'Data-Driven Approach',
      description: 'Real insights powering strategic decisions',
      iconUrl: '',
    },
  ],
};

const FOOTER_SOCIAL_META = [
  { field: 'socialLinkedInUrl', label: 'LinkedIn' },
  { field: 'socialFacebookUrl', label: 'Facebook' },
  { field: 'socialInstagramUrl', label: 'Instagram' },
  { field: 'socialXUrl', label: 'X' },
  { field: 'socialYoutubeUrl', label: 'YouTube' },
];

export const FOOTER_FALLBACK = {
  brandText:
    'Design amazing digital experiences that create more happy in the world.',
  brandLogoUrl: '',
  servicesTitle: 'Services',
  companyTitle: 'Company',
  legalTitle: 'Legal',
  copyrightText: '© Tevris. All rights reserved.',
  vucaLogoUrl: '',
  vucaLink: 'https://vuca.li/',
  serviceLinks: [
    { label: 'Turnkey Solutions', to: '/' },
    { label: 'Process Optimization', to: '/' },
    { label: 'Market Intelligence', to: '/' },
    { label: 'Business Consultancy', to: '/' },
    { label: 'New Brand Market Entry', to: '/' },
    { label: 'People & Organizations', to: '/' },
    { label: 'Financial Solutions', to: '/' },
    { label: 'Dealer Standards Audits', to: '/' },
  ],
  companyLinks: [
    { label: 'About us', to: '/' },
    { label: 'Core models', to: '/' },
    { label: 'Projects', to: '/' },
    { label: 'Key collaborations', to: '/' },
    { label: 'Careers', to: '/' },
    { label: 'Contacts', to: '/' },
  ],
  legalLinks: [
    { label: 'Terms', to: '/' },
    { label: 'Privacy', to: '/' },
    { label: 'Cookies', to: '/' },
    { label: 'Licenses', to: '/' },
    { label: 'Settings', to: '/' },
    { label: 'Contact', to: '/' },
  ],
  socialLinks: FOOTER_SOCIAL_META.map((s) => ({
    label: s.label,
    href: '#',
    iconUrl: '',
  })),
};

export const BOOK_CONSULT_FALLBACK = {
  title: 'Ready to Expand in Iraq?',
  subtitle: "Let's build your next automotive success story together.",
  buttonText: 'Book a consultation',
  buttonUrl: '/contact',
};

export const BUILD_FUTURE_FALLBACK = {
  title: "Let's Build the Future of Automotive in Iraq",
  subtitle: 'Partner with Tevris to unlock new growth opportunities.',
  buttonText: 'Get in Touch',
  buttonUrl: '/contact',
};

export const BUILD_A_CONNECT_FALLBACK = {
  title: 'Build a Connected Automotive Ecosystem',
  subtitle: 'Partner with Tevris to integrate every layer of your business.',
  buttonText: 'Get in Touch',
  buttonUrl: '/contact',
};

export const LOOKING_TO_EXPAND_FALLBACK = {
  title: 'Looking to Expand or Optimize Your Automotive Business?',
  subtitle: 'Partner with Tevris to unlock new growth opportunities in Iraq.',
  buttonText: 'Get in Touch',
  buttonUrl: '/contact',
};

export const PARTNERS_FALLBACK = {
  label: 'Join 4,000+ companies already growing',
  logos: [
    { name: 'Layers', src: '' },
    { name: 'Sisyphus', src: '' },
    { name: 'Circooles', src: '' },
    { name: 'Catalog', src: '' },
    { name: 'Quotient', src: '' },
  ],
};

export const ABOUT_TEVRIS_FALLBACK = {
  title: 'About Tevris',
  paragraphs: [
    'Founded in 2021, Tevris is an automotive consultancy dedicated to shaping Iraq\'s evolving automotive landscape.',
    "Our team brings leadership experience from some of the region's most successful automotive brands, combining global standards with deep local insight.",
    "We don't just advise — we partner with our clients to build sustainable, high-performing automotive businesses.",
  ],
  buttonText: 'Learn More',
  buttonUrl: '/about',
  imageUrl: '',
  imageAlt: 'Aerial view of a bridge over a braided river',
};

export const HERO_FALLBACK = {
  eyebrow: 'Expert Automotive Consultancy',
  title: "Your Strategic Partner in Iraq's Automotive Industry",
  description:
    'We help global automotive brands enter, grow, and lead in Iraq through data-driven strategies, operational excellence, and deep local expertise.',
  buttonText: 'Get a Consultation',
  buttonUrl: '/contact',
  backgroundImageUrl: '',
};

/** About page hero (no CTA in default UI). */
export const ABOUT_HERO_FALLBACK = {
  eyebrow: 'About Tevris',
  title: "Shaping the Future of Iraq's Automotive Industry",
  description:
    "We are a team of industry experts helping global automotive brands establish, grow, and lead in one of the region's most dynamic markets.",
  buttonText: '',
  buttonUrl: '',
  backgroundImageUrl: '',
};

export const SERVICE_DETAILS_VALUE_FALLBACK = {
  eyebrow: 'Value Delivered',
  title: 'Why Choose Tevris',
  description:
    'We provide full-cycle support to launch and operate automotive dealerships and distribution networks, ensuring seamless execution and long-term success.',
  items: [
    'Faster time-to-market',
    'Reduced operational risks',
    'Full compliance with OEM standards',
    'Experienced local execution',
    'Scalable and sustainable operations',
  ],
};

export const SERVICE_DETAILS_READY_TO_LAUNCH_FALLBACK = {
  title: 'Ready to Launch Your Automotive Business in Iraq?',
  subtitle:
    "Let's build your dealership or distribution network together.",
  buttonText: 'Get in Touch',
  buttonUrl: '/contact',
};

export const SERVICE_DETAILS_OUR_PROCESS_FALLBACK = {
  eyebrow: 'Our Process',
  title: 'A Structured Path to Operational Excellence',
  items: [
    {
      title: 'Assessment',
      description: 'Understanding your business goals and market conditions',
    },
    {
      title: 'Planning',
      description: 'Defining strategy, layout, and operational framework',
    },
    {
      title: 'Execution',
      description: 'Managing construction, setup, and implementation',
    },
    {
      title: 'Launch',
      description: 'Delivering a fully operational and optimized business',
    },
  ],
};

export const OUR_APPROACH_FALLBACK = {
  eyebrow: 'Our Approach',
  title: 'A Structured Approach to Automotive Growth',
  items: [
    {
      title: 'Unrivaled Local Expertise',
      description: "Deep understanding of Iraq's automotive landscape",
    },
    {
      title: 'Proven Experience & Legacy',
      description: 'Leadership background across top automotive brands',
    },
    {
      title: 'Pioneering Innovation',
      description: 'Introducing new business models and strategies',
    },
    {
      title: 'Operational Excellence',
      description: 'Focused on measurable performance and efficiency',
    },
  ],
};

export const INDUSTRY_COVERAGE_FALLBACK = {
  eyebrow: 'Industry Coverage',
  title: 'Supporting Every Layer of the Automotive Ecosystem',
  badges: [
    { label: 'Auto Brands & OEMs', iconUrl: '' },
    { label: 'Dealer Networks', iconUrl: '' },
    { label: 'Parts & Lubricants', iconUrl: '' },
    { label: 'Service Centers', iconUrl: '' },
    { label: 'Rental & Mobility', iconUrl: '' },
    { label: 'Accessories & Protection', iconUrl: '' },
  ],
};

export const THREE_LAYERS_FALLBACK = {
  eyebrow: 'Core Layers',
  title: 'Three Layers. One Ecosystem.',
  truckIconUrl: '',
  checkIconUrl: '',
  layers: [
    {
      id: 'layer-1',
      number: '01',
      title: 'Infrastructure & Equipment',
      description:
        'We provide the physical and operational foundation for automotive businesses, including equipment, tools, and facility setup aligned with global standards.',
      features: [
        'Equipment & tools',
        'Workshop setup',
        'Accessories development',
        'Facility standards',
      ],
      reversed: false,
      imageUrl: '',
    },
    {
      id: 'layer-2',
      number: '02',
      title: 'Distribution & Retail',
      description:
        'We enable efficient market access through structured distribution networks, dealer operations, and strategic brand positioning.',
      features: [
        'Official distributors',
        'Dealer networks',
        'Parts & lubricant distribution',
        'Brand positioning',
      ],
      reversed: true,
      imageUrl: '',
    },
    {
      id: 'layer-3',
      number: '03',
      title: 'Ownership Experience & Aftermarket',
      description:
        'We enhance the end-customer journey through after-sales services, mobility solutions, and long-term engagement strategies.',
      features: [
        'Aftersales services',
        'Rental solutions',
        'Car protection',
        'Customer engagement',
      ],
      reversed: false,
      imageUrl: '',
    },
  ],
};

export const WHY_IT_MATTERS_FALLBACK = {
  eyebrow: 'Why It Matters',
  title: 'Turning Complexity into Competitive Advantage',
  checkIconUrl: '',
  items: [
    {
      id: 'item-1',
      text: 'Integrated ecosystem instead of fragmented services',
      fullWidth: true,
    },
    { id: 'item-2', text: 'Faster market penetration', fullWidth: false },
    { id: 'item-3', text: 'Stronger operational control', fullWidth: false },
    { id: 'item-4', text: 'Scalable growth model', fullWidth: false },
    { id: 'item-5', text: 'Data-driven decision making', fullWidth: false },
  ],
};

export const DIGITAL_PLATFORM_FALLBACK = {
  eyebrow: 'Digital Platform',
  titleLine1: 'Connecting Global Traders',
  titleLine2: 'with Local Markets',
  description:
    'DXBCAR is an upcoming online vehicle marketplace designed to connect international car traders directly with end users, creating a seamless digital bridge between supply and demand.',
  backgroundImageUrl: '',
  logoUrl: '',
  logoAlt: 'DXBCAR',
};

export const ECO_SYSTEM_FALLBACK = {
  title: 'How the ecosystem works',
  description:
    'Tevris connects infrastructure, distribution, and ownership into a continuous value loop.',
  imageUrl: '',
  imageAlt:
    'How the Tevris ecosystem works — infrastructure, distribution, customer, and aftermarket connected in a continuous value loop',
};

export const LETTERS_FALLBACK = {
  textHighlight: "We don't just advise —",
  textMuted:
    'we connect infrastructure, distribution, and customer experience into one unified system that drives efficiency, scalability, and long-term growth.',
};

/** Core Models page hero (no CTA in default UI). */
export const CORE_MODELS_HERO_FALLBACK = {
  eyebrow: 'Core Models',
  title: 'Intelligent Hyper-Connectivity Across the Automotive Ecosystem',
  description:
    'We connect every layer of the automotive value chain — from equipment and distribution to after-sales and customer experience — creating integrated, high-performance business ecosystems.',
  buttonText: '',
  buttonUrl: '',
  backgroundImageUrl: '',
};

export const CONTACT_FORM_FALLBACK = {
  title: 'Get in touch',
  subtitle: 'Our friendly team would love to hear from you.',
  firstNameLabel: 'First name',
  firstNamePlaceholder: 'First name',
  lastNameLabel: 'Last name',
  lastNamePlaceholder: 'Last name',
  emailLabel: 'Email',
  emailPlaceholder: 'you@company.com',
  phoneNumberLabel: 'Phone number',
  phoneNumberPlaceholder: '+964 770 123 4567',
  messageLabel: 'Message',
  messagePlaceholder: 'Leave us a message...',
  imageUrl: '',
  imageAlt: 'Aerial view of a coastal highway beside the ocean',
};

export const CONTACT_HERO_FALLBACK = {
  eyebrow: 'Contact',
  title: "Let's build your next automotive project together",
  description:
    "Whether you're entering the market or scaling operations, Tevris provides the expertise and systems to make it happen.",
  backgroundImageUrl: '',
  cards: [
    {
      id: 'card-1',
      title: 'Phone',
      description: 'Speak with our team about your project needs.',
      detail: '+964 750 000 0000',
      href: 'tel:+9647500000000',
      iconUrl: '',
    },
    {
      id: 'card-2',
      title: 'Email',
      description: 'Send us a message and we will respond promptly.',
      detail: 'info@tevris.com',
      href: 'mailto:info@tevris.com',
      iconUrl: '',
    },
    {
      id: 'card-3',
      title: 'Office',
      description: 'Visit us at our headquarters in Iraq.',
      detail: 'Erbil, Kurdistan Region, Iraq',
      href: '',
      iconUrl: '',
    },
  ],
};

export const LETS_BUILD_FALLBACK = {
  title: "Let's build your next automotive project",
  subtitle:
    "Whether you're entering the market or scaling operations, Tevris provides the expertise and systems to make it happen.",
  buttonText: 'Start a project',
  buttonUrl: '/contact',
};

/** Projects listing page hero (primary + secondary CTAs). */
export const PROJECTS_HERO_FALLBACK = {
  eyebrow: 'Projects',
  title: 'Building automotive ecosystems that scale',
  description:
    'From workshop infrastructure to nationwide distribution and ownership experience — we design and implement systems that drive long-term growth.',
  secondaryButtonText: 'View case studies',
  secondaryButtonUrl: '#case-studies',
  buttonText: 'Start a project',
  buttonUrl: '/contact',
  backgroundImageUrl: '',
};

/** Services listing page hero (no CTA in default UI). */
export const SERVICES_HERO_FALLBACK = {
  eyebrow: 'Our Services',
  title: 'End-to-End Automotive Solutions for Growth',
  description:
    "From market entry to operational excellence, we deliver tailored solutions that help automotive brands succeed in Iraq's complex and evolving market.",
  buttonText: '',
  buttonUrl: '',
  backgroundImageUrl: '',
};

/** Collaborations page hero (no CTA in default UI). */
export const COLLABORATIONS_HERO_FALLBACK = {
  eyebrow: 'Key Collaborations',
  title: 'Trusted by global automotive brands',
  description:
    'We collaborate with leading manufacturers and industry players to deliver high-standard solutions across infrastructure, distribution, and ownership experience.',
  buttonText: '',
  buttonUrl: '',
  backgroundImageUrl: '',
};

/** Collaborations brands marquee section. */
export const BRANDS_FALLBACK = {
  title: 'Brands we work with',
  logos: BRAND_LOGOS,
  rows: BRANDS_ROWS,
};

/** Collaborations main blocks (Toyota, Nissan, Geely, …). */
export const COLLABORATIONS_MAIN_FALLBACK = {
  sections: COLLABORATIONS_MAIN_SECTIONS,
  checkIconUrl: checkIconFallback,
};

/** Collaborations how-we-collaborate cards section. */
export const HOW_WE_COLLABORATE_FALLBACK = {
  title: 'How we collaborate',
  description:
    'Our partnerships are built on long-term value, operational excellence, and deep market understanding.',
  items: HOW_WE_COLLABORATE_ITEMS,
};

/** Collaborations why-it section (bullet list). */
export const COLLABORATIONS_WHY_IT_FALLBACK = {
  eyebrow: 'Why It Matters',
  title: 'Impact across the automotive sector',
  checkIconUrl: checkIconFallback,
  items: WHY_IT_ITEMS.map((text, index) => ({
    id: `why-it-${index + 1}`,
    text,
    fullWidth: false,
  })),
};

const LOCAL_EXPERTISE_GALLERY_SLOTS = ['g1', 'g2', 'g3', 'g4', 'g5'];

const OUR_PURPOSE_CARD_MODIFIERS = ['mission', 'vision'];

export const OUR_PURPOSE_FALLBACK = {
  eyebrow: 'Our Purpose',
  title: 'Driven by Vision. Defined by Impact.',
  cards: [
    {
      title: 'Mission',
      text: "To empower Iraq's automotive industry through innovative, data-driven, and sustainable strategies that enhance operational efficiency, profitability, and customer experience.",
      iconUrl: '',
      modifier: 'mission',
    },
    {
      title: 'Vision',
      text: 'To be the most trusted partner for automotive growth and transformation in Iraq, fostering industry leadership through excellence, innovation, and integrity.',
      iconUrl: '',
      modifier: 'vision',
    },
  ],
};

export const OUR_VALUES_FALLBACK = {
  eyebrow: 'Our Values',
  title: 'The Principles Behind Every Partnership',
  backgroundImageUrl: '',
  values: [
    {
      title: 'Unrivaled Local Expertise',
      description: "Deep understanding of Iraq's automotive landscape",
      iconUrl: '',
    },
    {
      title: 'Proven Experience & Legacy',
      description: 'Leadership background across top automotive brands',
      iconUrl: '',
    },
    {
      title: 'Pioneering Innovation',
      description: 'Introducing new business models and strategies',
      iconUrl: '',
    },
    {
      title: 'Operational Excellence',
      description: 'Focused on measurable performance and efficiency',
      iconUrl: '',
    },
    {
      title: 'Confidentiality & Integrity',
      description: 'Trusted partnerships built on transparency',
      iconUrl: '',
    },
    {
      title: 'Long-term Value Creation',
      description: 'Sustainable growth over short-term wins',
      iconUrl: '',
    },
  ],
  showcaseCards: [
    {
      title: 'Foresight',
      description:
        'Anticipating trends to create unique market opportunities.',
    },
    {
      title: 'Credibility',
      description:
        'Building trust through consistent excellence and integrity.',
    },
    {
      title: 'Innovation',
      description: 'Delivering solutions that redefine industry standards.',
    },
  ],
};

export const OUR_IMPACT_FALLBACK = {
  title: 'Our Impact in Numbers',
  stats: [
    { end: 7, label: 'Distribution Centers', prefix: '', suffix: '', decimals: 0 },
    {
      end: 730,
      label: 'Local Garages & Resellers',
      prefix: '',
      suffix: '+',
      decimals: 0,
    },
    {
      end: 12.6,
      label: 'Annual Revenue',
      prefix: '$',
      suffix: 'M',
      decimals: 1,
    },
    { end: 1600, label: 'SKUs', prefix: '', suffix: '+', decimals: 0 },
  ],
};

export const LOCAL_EXPERTISE_FALLBACK = {
  title: 'Local Expertise with Global Standards',
  paragraphs: [
    "Founded in 2021, Tevris Automotive Consultancy supports Iraq's automotive industry with deep local expertise and international best practices.",
    "Our team has held leadership roles in some of the country's most respected automotive brands, bringing hands-on experience across distribution, retail, and after-sales operations.",
    'We focus on building long-term partnerships, helping our clients transform operational complexity into sustainable growth and market leadership.',
  ],
  images: [
    { src: '', alt: 'White SUV parked outdoors', slot: 'g1' },
    { src: '', alt: 'Person photographing a vehicle', slot: 'g2' },
    { src: '', alt: 'Toyota dealership building at dusk', slot: 'g3' },
    { src: '', alt: 'Automotive technician working on a vehicle', slot: 'g4' },
    { src: '', alt: 'Premium leather car interior seats', slot: 'g5' },
  ],
};

function pickMediaUrl(media) {
  if (!media || typeof media !== 'object') return '';
  const primary = media.primary ?? media.Primary;
  if (primary?.url || primary?.Url) {
    return String(primary.url ?? primary.Url);
  }
  const images = media.images ?? media.Images;
  if (Array.isArray(images) && images[0]) {
    return String(images[0].url ?? images[0].Url ?? '');
  }
  return '';
}

function pickMediaGroupList(media, groupKey) {
  if (!media || typeof media !== 'object') return [];
  const groups = media.groups ?? media.Groups;
  if (!groups || typeof groups !== 'object') return [];
  const list =
    groups[groupKey] ??
    groups[groupKey.charAt(0).toUpperCase() + groupKey.slice(1)];
  if (!Array.isArray(list)) return [];
  return [...list].sort(
    (a, b) => Number(a.sortOrder ?? a.SortOrder ?? 0) - Number(b.sortOrder ?? b.SortOrder ?? 0)
  );
}

function extractAdvantageCards(fields, iconList) {
  const cards = [];
  for (let i = 1; i <= 8; i += 1) {
    const title = fields[`card${i}Title`];
    const description = fields[`card${i}Description`];
    if (title == null && description == null) continue;
    if (!String(title ?? '').trim() && !String(description ?? '').trim()) {
      continue;
    }
    const icon = iconList[i - 1];
    const path = icon?.url ?? icon?.Url ?? '';
    cards.push({
      title: String(title ?? ''),
      description: String(description ?? ''),
      iconUrl: path ? resolveMediaUrl(path) : '',
    });
  }
  return cards;
}

function extractValueItems(fields, iconList, max = 6) {
  const items = [];
  for (let i = 1; i <= max; i += 1) {
    const title = fields[`value${i}Title`];
    const description = fields[`value${i}Description`];
    if (title == null && description == null) continue;
    if (!String(title ?? '').trim() && !String(description ?? '').trim()) {
      continue;
    }
    const icon = iconList[i - 1];
    const path = icon?.url ?? icon?.Url ?? '';
    items.push({
      title: String(title ?? ''),
      description: String(description ?? ''),
      iconUrl: path ? resolveMediaUrl(path) : '',
    });
  }
  return items;
}

function optionalStatString(value) {
  if (value == null) return '';
  const s = String(value).trim();
  return s && s.toLowerCase() !== 'null' ? s : '';
}

function extractIndustryBadges(fields, iconList, max = 6) {
  const badges = [];
  for (let i = 1; i <= max; i += 1) {
    const label = fields[`badge${i}Label`];
    if (!String(label ?? '').trim()) continue;
    const icon = iconList[i - 1];
    const path = icon?.url ?? icon?.Url ?? '';
    badges.push({
      label: String(label).trim(),
      iconUrl: path ? resolveMediaUrl(path) : '',
    });
  }
  return badges;
}

function extractBadgeLabels(fields, max = 8) {
  const labels = [];
  for (let i = 1; i <= max; i += 1) {
    const label = fields[`badge${i}Label`];
    if (!String(label ?? '').trim()) continue;
    labels.push(String(label).trim());
  }
  return labels;
}

function extractImpactStats(fields, max = 4) {
  const stats = [];
  for (let i = 1; i <= max; i += 1) {
    const endRaw = fields[`stat${i}End`];
    const label = fields[`stat${i}Label`];
    if (endRaw == null && label == null) continue;
    const end = Number(endRaw);
    if (!Number.isFinite(end)) continue;
    const decimals = Number(fields[`stat${i}Decimals`]);
    stats.push({
      end,
      label: String(label ?? ''),
      prefix: optionalStatString(fields[`stat${i}Prefix`]),
      suffix: optionalStatString(fields[`stat${i}Suffix`]),
      decimals: Number.isFinite(decimals) ? decimals : 0,
    });
  }
  return stats;
}

function parseBooleanField(value, fallback = false) {
  if (value == null) return fallback;
  const s = String(value).trim().toLowerCase();
  if (s === 'true' || s === '1') return true;
  if (s === 'false' || s === '0') return false;
  return fallback;
}

function extractLayerFeatures(fields, layerIndex, max = 4) {
  const features = [];
  for (let f = 1; f <= max; f += 1) {
    const text = fields[`layer${layerIndex}Feature${f}`];
    if (String(text ?? '').trim()) {
      features.push(String(text).trim());
    }
  }
  return features;
}

function extractThreeLayersFromFields(
  fields,
  layerImages,
  fallbackLayers = [],
  max = 3
) {
  const layers = [];
  for (let i = 1; i <= max; i += 1) {
    const title = fields[`layer${i}Title`];
    if (!String(title ?? '').trim()) continue;
    const imageItem = layerImages[i - 1];
    const path = imageItem?.url ?? imageItem?.Url ?? '';
    layers.push({
      id: `layer-${i}`,
      number: String(
        fields[`layer${i}Number`] ?? String(i).padStart(2, '0')
      ),
      title: String(title).trim(),
      description: String(fields[`layer${i}Description`] ?? ''),
      features: extractLayerFeatures(fields, i),
      reversed: parseBooleanField(
        fields[`layer${i}Reversed`],
        fallbackLayers[i - 1]?.reversed ?? false
      ),
      imageUrl: path ? resolveMediaUrl(path) : '',
    });
  }
  return layers;
}

function extractWhyItMattersItems(fields, max = 5) {
  const items = [];
  for (let i = 1; i <= max; i += 1) {
    const text = fields[`item${i}Text`];
    if (!String(text ?? '').trim()) continue;
    items.push({
      id: `item-${i}`,
      text: String(text).trim(),
      fullWidth: parseBooleanField(fields[`item${i}FullWidth`], false),
    });
  }
  return items;
}

function extractShowcaseCards(fields, max = 3) {
  const cards = [];
  for (let i = 1; i <= max; i += 1) {
    const title = fields[`showcase${i}Title`];
    const description = fields[`showcase${i}Description`];
    if (title == null && description == null) continue;
    if (!String(title ?? '').trim() && !String(description ?? '').trim()) {
      continue;
    }
    cards.push({
      title: String(title ?? ''),
      description: String(description ?? ''),
    });
  }
  return cards;
}

function pickBackgroundImageUrl(media, fallbackUrl = '') {
  const bgList = pickMediaGroupList(media, 'background');
  const path =
    String(bgList[0]?.url ?? bgList[0]?.Url ?? '').trim() ||
    pickMediaUrl(media);
  return path ? resolveMediaUrl(path) : fallbackUrl;
}

function extractTextParagraphs(fields) {
  const paragraphs = [];
  const keys = Object.keys(fields).filter((k) => /^text\d+$/i.test(k));
  keys.sort((a, b) => {
    const na = Number(a.replace(/\D/g, '')) || 0;
    const nb = Number(b.replace(/\D/g, '')) || 0;
    return na - nb;
  });
  for (const key of keys) {
    const text = String(fields[key] ?? '').trim();
    if (text) paragraphs.push(text);
  }
  return paragraphs;
}

function pickAboutImage(media) {
  const path = pickMediaUrl(media);
  if (path) return { path, alt: pickMediaAlt(media) };
  const main = pickMediaGroupList(media, 'main');
  if (main[0]) {
    return {
      path: String(main[0].url ?? main[0].Url ?? ''),
      alt: String(main[0].altText ?? main[0].AltText ?? ''),
    };
  }
  return { path: '', alt: '' };
}

function pickMediaAlt(media) {
  if (!media || typeof media !== 'object') return '';
  const primary = media.primary ?? media.Primary;
  if (primary?.altText ?? primary?.AltText) {
    return String(primary.altText ?? primary.AltText);
  }
  const images = media.images ?? media.Images;
  if (Array.isArray(images) && images[0]) {
    return String(images[0].altText ?? images[0].AltText ?? '');
  }
  return '';
}

export function normalizePublicPage(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const sections = raw.sections ?? raw.Sections ?? [];
  return {
    id: raw.id ?? raw.Id,
    name: String(raw.name ?? raw.Name ?? ''),
    slug: String(raw.slug ?? raw.Slug ?? ''),
    language: String(raw.language ?? raw.Language ?? ''),
    sections: Array.isArray(sections)
      ? sections.map(normalizePublicSection).filter(Boolean)
      : [],
  };
}

export function normalizePublicSection(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const fields = raw.fields ?? raw.Fields ?? {};
  return {
    id: raw.id ?? raw.Id,
    key: String(raw.key ?? raw.Key ?? ''),
    name: String(raw.name ?? raw.Name ?? ''),
    type: String(raw.type ?? raw.Type ?? ''),
    sortOrder: Number(raw.sortOrder ?? raw.SortOrder ?? 0),
    fields: typeof fields === 'object' && fields !== null ? { ...fields } : {},
    media: raw.media ?? raw.Media ?? null,
  };
}

/** Contact page hero (dashboard uses key "contact-hero"). */
export function getContactHeroSection(page) {
  return (
    getSectionByKey(page, 'contact-hero') ??
    getSectionByKey(page, 'hero')
  );
}

/** Home advantage section (API key is often "the-tevris-advantage"). */
export function getAdvantageSection(page) {
  return (
    getSectionByKey(page, 'the-tevris-advantage') ??
    getSectionByKey(page, 'advantage')
  );
}

/** Core Models page hero (API key is "core-models-hero"). */
export function getCoreModelsHeroSection(page) {
  return (
    getSectionByKey(page, 'core-models-hero') ??
    getSectionByKey(page, 'hero')
  );
}

/** Find section by `key` (e.g. "hero"). */
export function getSectionByKey(page, sectionKey) {
  if (!page?.sections?.length || !sectionKey) return null;
  const key = String(sectionKey).toLowerCase();
  return (
    page.sections.find((s) => String(s.key).toLowerCase() === key) ?? null
  );
}

/** whatweoffer text-block (aliases used on home / services pages). */
export function getWhatWeOfferSection(page) {
  return (
    getSectionByKey(page, 'whatweoffer') ??
    getSectionByKey(page, 'what-we-offer') ??
    getSectionByKey(page, 'all-services')
  );
}

/** success-story text-block (home success stories section header). */
export function getSuccessStorySection(page) {
  return (
    getSectionByKey(page, 'success-story') ??
    getSectionByKey(page, 'success-stories') ??
    getSectionByKey(page, 'successstory')
  );
}

/** blogs text-block (home blog section header). */
export function getBlogsSection(page) {
  return (
    getSectionByKey(page, 'blogs') ??
    getSectionByKey(page, 'blog')
  );
}

/** navbar custom section (site-wide nav from home page). */
export function getNavbarSection(page) {
  return getSectionByKey(page, 'navbar');
}

function parseBoolField(value, fallback = false) {
  if (value === true || value === false) return value;
  const normalized = String(value ?? '')
    .trim()
    .toLowerCase();
  if (normalized === 'true' || normalized === '1') return true;
  if (normalized === 'false' || normalized === '0') return false;
  return fallback;
}

function pickGalleryImageList(media) {
  const fromGroup = pickMediaGroupList(media, 'gallery');
  if (fromGroup.length > 0) return fromGroup;
  const images = media?.images ?? media?.Images;
  if (!Array.isArray(images)) return [];
  return [...images].sort(
    (a, b) =>
      Number(a.sortOrder ?? a.SortOrder ?? 0) -
      Number(b.sortOrder ?? b.SortOrder ?? 0)
  );
}

function mapGalleryImages(media, fallbackImages) {
  const list = pickGalleryImageList(media);
  const slots = LOCAL_EXPERTISE_GALLERY_SLOTS;
  const mapped = list.slice(0, slots.length).map((item, index) => {
    const path = String(item?.url ?? item?.Url ?? '').trim();
    const fb = fallbackImages[index] ?? fallbackImages[0] ?? {};
    return {
      src: path ? resolveMediaUrl(path) : fb.src ?? '',
      alt: String(item?.altText ?? item?.AltText ?? fb.alt ?? ''),
      slot: slots[index] ?? `g${index + 1}`,
    };
  });
  if (mapped.length > 0) return mapped;
  return fallbackImages.map((img) => ({ ...img }));
}

/** Map our-purpose section → props for About OurPurpose component. */
export function mapOurPurposeContent(
  section,
  fallback = OUR_PURPOSE_FALLBACK
) {
  const fields = section?.fields ?? {};
  const icons = pickMediaGroupList(section?.media, 'icons');
  const rawCards = extractAdvantageCards(fields, icons).slice(0, 2);
  const cards =
    rawCards.length > 0
      ? rawCards.map((card, index) => ({
          title: card.title,
          text: card.description,
          iconUrl: card.iconUrl,
          modifier:
            OUR_PURPOSE_CARD_MODIFIERS[index] ??
            OUR_PURPOSE_CARD_MODIFIERS[0],
        }))
      : fallback.cards.map((card) => ({ ...card }));

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    cards,
  };
}

/** Map our-values section → props for About OurValues component. */
export function mapOurValuesContent(
  section,
  fallback = OUR_VALUES_FALLBACK
) {
  const fields = section?.fields ?? {};
  const icons = pickMediaGroupList(section?.media, 'icons');
  const values = extractValueItems(fields, icons);
  const showcaseCards = extractShowcaseCards(fields);
  const backgroundImageUrl = pickBackgroundImageUrl(
    section?.media,
    fallback.backgroundImageUrl
  );

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    backgroundImageUrl,
    values:
      values.length > 0
        ? values
        : fallback.values.map((item) => ({ ...item })),
    showcaseCards:
      showcaseCards.length > 0
        ? showcaseCards
        : fallback.showcaseCards.map((card) => ({ ...card })),
  };
}

/** Map our-impact section → props for About OurImpact component. */
export function mapOurImpactContent(
  section,
  fallback = OUR_IMPACT_FALLBACK
) {
  const fields = section?.fields ?? {};
  const stats = extractImpactStats(fields);

  return {
    title: String(fields.title ?? fallback.title),
    stats:
      stats.length > 0
        ? stats
        : fallback.stats.map((stat) => ({ ...stat })),
  };
}

/** Map local-expertise section → props for About LocalExpertise component. */
export function mapLocalExpertiseContent(
  section,
  fallback = LOCAL_EXPERTISE_FALLBACK
) {
  const fields = section?.fields ?? {};
  const paragraphs = extractTextParagraphs(fields);
  const images = mapGalleryImages(section?.media, fallback.images);

  return {
    title: String(fields.title ?? fallback.title),
    paragraphs:
      paragraphs.length > 0 ? paragraphs : [...fallback.paragraphs],
    images: images.length > 0 ? images : fallback.images.map((img) => ({ ...img })),
  };
}

function mapCardsSectionContent(section, fallback) {
  const fields = section?.fields ?? {};
  const rawCards = extractAdvantageCards(fields, []).slice(0, 4);
  const items =
    rawCards.length > 0
      ? rawCards.map((card) => ({
          title: card.title,
          description: card.description,
        }))
      : fallback.items.map((item) => ({ ...item }));

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    items,
  };
}

/** our-process cards section on the services page. */
export function getOurProcessSection(page) {
  return getSectionByKey(page, 'our-process');
}

/** Map our-process section → props for ServiceDetailsOurProcess. */
export function mapOurProcessContent(
  section,
  fallback = SERVICE_DETAILS_OUR_PROCESS_FALLBACK
) {
  return mapCardsSectionContent(section, fallback);
}

/** value-delivered section on the services page. */
export function getValueDeliveredSection(page) {
  return getSectionByKey(page, 'value-delivered');
}

/** Map value-delivered section → props for ServiceDetailsValue. */
export function mapValueDeliveredContent(
  section,
  fallback = SERVICE_DETAILS_VALUE_FALLBACK
) {
  const fields = section?.fields ?? {};
  const items = extractBadgeLabels(fields, 8);

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
    items: items.length > 0 ? items : [...fallback.items],
  };
}

/** ready-to-launch text-block on the services page. */
export function getReadyToLaunchSection(page) {
  return getSectionByKey(page, 'ready-to-launch');
}

/** Map ready-to-launch section → props for ServiceDetailsReadyToLaunch. */
export function mapReadyToLaunchContent(
  section,
  fallback = SERVICE_DETAILS_READY_TO_LAUNCH_FALLBACK
) {
  return mapBookConsultContent(section, fallback);
}

/** Map our-approach section → props for Services OurApproach component. */
export function mapOurApproachContent(
  section,
  fallback = OUR_APPROACH_FALLBACK
) {
  return mapCardsSectionContent(section, fallback);
}

/** Map industry-coverage section → props for Services IndustryCoverage. */
export function mapIndustryCoverageContent(
  section,
  fallback = INDUSTRY_COVERAGE_FALLBACK
) {
  const fields = section?.fields ?? {};
  const icons = pickMediaGroupList(section?.media, 'icons');
  const badges = extractIndustryBadges(fields, icons);

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    badges:
      badges.length > 0
        ? badges
        : fallback.badges.map((badge) => ({ ...badge })),
  };
}

function parseBrandKeysCsv(csv) {
  return String(csv ?? '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

function parseSectionBool(value) {
  if (typeof value === 'boolean') return value;
  return String(value ?? '').toLowerCase() === 'true';
}

function buildBrandLogoMap(media, fallbackLogos) {
  const map = { ...fallbackLogos };
  const list = pickMediaGroupList(media, 'logos');
  for (const item of list) {
    const key = String(item.caption ?? item.Caption ?? '')
      .trim()
      .toLowerCase();
    if (!key) continue;
    const path = item.url ?? item.Url ?? '';
    map[key] = {
      src: path ? resolveMediaUrl(path) : (fallbackLogos[key]?.src ?? ''),
      name: String(
        item.altText ?? item.AltText ?? fallbackLogos[key]?.name ?? key
      ),
    };
  }
  return map;
}

function buildCollaborationBlockImageMap(media, fallbackSections) {
  const map = {};
  for (const s of fallbackSections) {
    map[s.id] = s.image;
  }
  const list = pickMediaGroupList(media, 'blocks');
  for (const item of list) {
    const key = String(item.caption ?? item.Caption ?? '')
      .trim()
      .toLowerCase();
    if (!key) continue;
    const path = item.url ?? item.Url ?? '';
    if (path) map[key] = resolveMediaUrl(path);
  }
  return map;
}

function extractCollaborationMainBlocks(fields, imageMap, fallbackSections) {
  const sections = [];
  for (let i = 1; i <= 6; i += 1) {
    const title = fields[`block${i}Title`];
    if (!String(title ?? '').trim()) continue;
    const id = String(fields[`block${i}Id`] ?? `block-${i}`)
      .trim()
      .toLowerCase();
    const features = [];
    for (let f = 1; f <= 10; f += 1) {
      const feat = fields[`block${i}Feature${f}`];
      if (String(feat ?? '').trim()) features.push(String(feat).trim());
    }
    const fb = fallbackSections.find((s) => s.id === id);
    sections.push({
      id,
      eyebrow: String(fields[`block${i}Eyebrow`] ?? fb?.eyebrow ?? ''),
      title: String(title).trim(),
      description: String(
        fields[`block${i}Description`] ?? fb?.description ?? ''
      ),
      features: features.length > 0 ? features : (fb?.features ?? []),
      image: imageMap[id] ?? fb?.image ?? '',
      reversed: parseSectionBool(fields[`block${i}Reversed`]),
    });
  }
  return sections;
}

function pickCollaborationCheckIcon(media, fallbackUrl) {
  const icons = pickMediaGroupList(media, 'icons');
  const path = icons[0]?.url ?? icons[0]?.Url ?? '';
  return path ? resolveMediaUrl(path) : fallbackUrl;
}

function buildCaptionIconMap(media, fallbackItems) {
  const map = {};
  for (const item of fallbackItems) {
    map[item.id] = item.icon;
  }
  const list = pickMediaGroupList(media, 'icons');
  for (const icon of list) {
    const key = String(icon.caption ?? icon.Caption ?? '')
      .trim()
      .toLowerCase();
    if (!key) continue;
    const path = icon.url ?? icon.Url ?? '';
    if (path) map[key] = resolveMediaUrl(path);
  }
  return map;
}

function extractHowWeCollaborateCards(fields, iconMap, fallbackItems) {
  const items = [];
  for (let i = 1; i <= 8; i += 1) {
    const title = fields[`card${i}Title`];
    if (!String(title ?? '').trim()) continue;
    const id = String(fields[`card${i}Id`] ?? `card-${i}`)
      .trim()
      .toLowerCase();
    const fb = fallbackItems.find((x) => x.id === id);
    items.push({
      id,
      title: String(title).trim(),
      description: String(
        fields[`card${i}Description`] ?? fb?.description ?? ''
      ),
      icon: iconMap[id] ?? fb?.icon ?? '',
    });
  }
  return items;
}

/** Map how-we-collaborate section → props for HowWeCollaborate. */
export function mapHowWeCollaborateContent(
  section,
  fallback = HOW_WE_COLLABORATE_FALLBACK
) {
  const fields = section?.fields ?? {};
  const iconMap = buildCaptionIconMap(section?.media, fallback.items);
  const items = extractHowWeCollaborateCards(
    fields,
    iconMap,
    fallback.items
  );

  return {
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
    items: items.length > 0 ? items : fallback.items,
  };
}

/** Map collaborations-main section → props for CollaborationsMain. */
export function mapCollaborationsMainContent(
  section,
  fallback = COLLABORATIONS_MAIN_FALLBACK
) {
  const fields = section?.fields ?? {};
  const imageMap = buildCollaborationBlockImageMap(
    section?.media,
    fallback.sections
  );
  const sections = extractCollaborationMainBlocks(
    fields,
    imageMap,
    fallback.sections
  );

  return {
    sections: sections.length > 0 ? sections : fallback.sections,
    checkIconUrl: pickCollaborationCheckIcon(
      section?.media,
      fallback.checkIconUrl
    ),
  };
}

/** Map collaborations brands section → props for Brands component. */
export function mapBrandsContent(section, fallback = BRANDS_FALLBACK) {
  const fields = section?.fields ?? {};
  const logos = buildBrandLogoMap(section?.media, fallback.logos);
  const rows = [];

  for (let i = 1; i <= 3; i += 1) {
    const brands = parseBrandKeysCsv(fields[`row${i}Brands`]);
    if (brands.length === 0) continue;
    rows.push({
      id: `row-${i}`,
      brands,
      centered: parseSectionBool(fields[`row${i}Centered`]),
    });
  }

  return {
    title: String(fields.title ?? fallback.title),
    logos,
    rows: rows.length > 0 ? rows : fallback.rows,
  };
}

/** Map hero section → props for Home Hero component. */
export function mapHeroContent(section, fallback = HERO_FALLBACK) {
  const fields = section?.fields ?? {};
  const path = pickMediaUrl(section?.media);
  const backgroundImageUrl = path
    ? resolveMediaUrl(path)
    : fallback.backgroundImageUrl;

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
    buttonText: String(fields.buttonText ?? fallback.buttonText),
    buttonUrl: String(fields.buttonUrl ?? fallback.buttonUrl),
    backgroundImageUrl: backgroundImageUrl || fallback.backgroundImageUrl,
  };
}

/** Map core-models hero section → API-only props for CoreModelsHero. */
export function mapCoreModelsHeroContent(section) {
  const fields = section?.fields ?? section?.Fields ?? {};
  const media = section?.media ?? section?.Media ?? null;
  const path = pickMediaUrl(media);

  return {
    eyebrow: String(fields.eyebrow ?? ''),
    title: String(fields.title ?? ''),
    description: String(fields.description ?? ''),
    backgroundImageUrl: path ? resolveMediaUrl(path) : '',
  };
}

function pickContactHeroBackground(media) {
  if (!media || typeof media !== 'object') return '';
  const background = pickMediaGroupList(media, 'background');
  if (background[0]) {
    const path = String(background[0].url ?? background[0].Url ?? '').trim();
    if (path) return resolveMediaUrl(path);
  }
  const path = pickMediaUrl(media);
  return path ? resolveMediaUrl(path) : '';
}

function extractContactHeroCards(fields, iconList, max = 3) {
  const cards = [];
  for (let i = 1; i <= max; i += 1) {
    const title = fields[`card${i}Title`];
    if (!String(title ?? '').trim()) continue;
    const icon = iconList[i - 1];
    const path = icon?.url ?? icon?.Url ?? '';
    const url = fields[`card${i}Url`];
    const href =
      url != null && String(url).trim() ? String(url).trim() : '';
    cards.push({
      id: `card-${i}`,
      title: String(title).trim(),
      description: String(fields[`card${i}Description`] ?? ''),
      detail: String(fields[`card${i}Detail`] ?? ''),
      href,
      iconUrl: path ? resolveMediaUrl(path) : '',
    });
  }
  return cards;
}

/** Map contact hero section → props for Contact ContactHero component. */
export function mapContactHeroContent(section) {
  const fields = section?.fields ?? section?.Fields ?? {};
  const media = section?.media ?? section?.Media ?? null;

  return {
    eyebrow: String(fields.eyebrow ?? ''),
    title: String(fields.title ?? ''),
    description: String(fields.description ?? ''),
    backgroundImageUrl: pickContactHeroBackground(media),
    cards: extractContactHeroCards(fields, pickMediaGroupList(media, 'cards')),
  };
}

/** Map contact-form section → props for Contact ContactForm (copy + image only). */
export function mapContactFormContent(
  section,
  fallback = CONTACT_FORM_FALLBACK
) {
  const fields = section?.fields ?? {};
  const { imageUrl, imageAlt } = pickMainSectionImage(
    section?.media,
    fallback
  );

  return {
    title: String(fields.title ?? fallback.title),
    subtitle: String(fields.subtitle ?? fallback.subtitle),
    firstNameLabel: String(
      fields.firstNameLabel ?? fallback.firstNameLabel
    ),
    firstNamePlaceholder: String(
      fields.firstNamePlaceholder ?? fallback.firstNamePlaceholder
    ),
    lastNameLabel: String(fields.lastNameLabel ?? fallback.lastNameLabel),
    lastNamePlaceholder: String(
      fields.lastNamePlaceholder ?? fallback.lastNamePlaceholder
    ),
    emailLabel: String(fields.emailLabel ?? fallback.emailLabel),
    emailPlaceholder: String(
      fields.emailPlaceholder ?? fallback.emailPlaceholder
    ),
    phoneNumberLabel: String(
      fields.phoneNumberLabel ?? fallback.phoneNumberLabel
    ),
    phoneNumberPlaceholder: String(
      fields.phoneNumberPlaceholder ?? fallback.phoneNumberPlaceholder
    ),
    messageLabel: String(fields.messageLabel ?? fallback.messageLabel),
    messagePlaceholder: String(
      fields.messagePlaceholder ?? fallback.messagePlaceholder
    ),
    imageUrl,
    imageAlt,
  };
}

/** Map projects hero section → props for Projects ProjectsHero component. */
export function mapProjectsHeroContent(
  section,
  fallback = PROJECTS_HERO_FALLBACK
) {
  const fields = section?.fields ?? {};
  const base = mapHeroContent(section, fallback);

  return {
    ...base,
    secondaryButtonText: String(
      fields.secondaryButtonText ?? fallback.secondaryButtonText
    ),
    secondaryButtonUrl: String(
      fields.secondaryButtonUrl ?? fallback.secondaryButtonUrl
    ),
  };
}

/** Map whatweoffer text-block → section header (eyebrow, title, description). */
export function mapWhatWeOfferContent(
  section,
  fallback = WHAT_WE_OFFER_FALLBACK
) {
  const fields = section?.fields ?? {};
  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
  };
}

/** Map success-story text-block → section header (eyebrow, title, description). */
export function mapSuccessStoryContent(
  section,
  fallback = SUCCESS_STORY_FALLBACK
) {
  const fields = section?.fields ?? {};
  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
  };
}

/** Map blogs text-block → section header (eyebrow, title, description). */
export function mapBlogsSectionContent(
  section,
  fallback = BLOGS_SECTION_FALLBACK
) {
  const fields = section?.fields ?? {};
  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
  };
}

/** Map navbar custom section → labels, routes, logo. */
export function mapNavbarContent(section, fallback = NAVBAR_FALLBACK) {
  const fields = section?.fields ?? {};
  const str = (key) => String(fields[key] ?? fallback[key] ?? '');

  const strings = {
    about: str('about'),
    services: str('services'),
    coreModels: str('coreModels'),
    projects: str('projects'),
    collaborations: str('collaborations'),
    contact: str('contact'),
    openMenu: str('openMenu'),
    closeMenu: str('closeMenu'),
  };

  const t = (key) => strings[key] ?? fallback[key] ?? key;

  const navLinks = [
    { key: 'about', label: strings.about, to: str('aboutTo') },
    {
      key: 'services',
      label: strings.services,
      to: str('servicesTo'),
      hasSubmenu: parseBoolField(
        fields.servicesHasSubmenu,
        fallback.servicesHasSubmenu
      ),
    },
    { key: 'coreModels', label: strings.coreModels, to: str('coreModelsTo') },
    { key: 'projects', label: strings.projects, to: str('projectsTo') },
    {
      key: 'collaborations',
      label: strings.collaborations,
      to: str('collaborationsTo'),
    },
  ];

  const logoPath = pickMediaUrl(section?.media);
  const logoUrl = logoPath ? resolveMediaUrl(logoPath) : '';
  const logoAlt = pickMediaAlt(section?.media) || fallback.logoAlt;

  return {
    t,
    navLinks,
    strings,
    contactTo: str('contactTo'),
    logoUrl,
    logoAlt,
  };
}

/** Map advantage section → props for Home Advantage component. */
export function mapAdvantageContent(section) {
  const fields = section?.fields ?? section?.Fields ?? {};
  const media = section?.media ?? section?.Media ?? null;
  const icons = pickMediaGroupList(media, 'icons');

  return {
    eyebrow: String(fields.eyebrow ?? ''),
    title: String(fields.title ?? ''),
    description: String(fields.description ?? ''),
    items: extractAdvantageCards(fields, icons),
  };
}

/** Map about-tevris section → props for Home AboutTervis component. */
export function mapAboutTervisContent(
  section,
  fallback = ABOUT_TEVRIS_FALLBACK
) {
  const fields = section?.fields ?? {};
  const paragraphs = extractTextParagraphs(fields);
  const { path, alt } = pickAboutImage(section?.media);
  const imageUrl = path ? resolveMediaUrl(path) : fallback.imageUrl;

  return {
    title: String(fields.title ?? fallback.title),
    paragraphs:
      paragraphs.length > 0 ? paragraphs : [...fallback.paragraphs],
    buttonText: String(fields.buttonText ?? fallback.buttonText),
    buttonUrl: String(fields.buttonUrl ?? fallback.buttonUrl),
    imageUrl: imageUrl || fallback.imageUrl,
    imageAlt: alt || fallback.imageAlt,
  };
}

/** Map partners section → props for Home Partners component. */
export function mapPartnersContent(section, fallback = PARTNERS_FALLBACK) {
  const fields = section?.fields ?? {};
  const logoList = pickMediaGroupList(section?.media, 'logos');
  const logos = logoList
    .map((item, index) => {
      const path = String(item.url ?? item.Url ?? '').trim();
      if (!path) return null;
      return {
        name: String(item.altText ?? item.AltText ?? `Partner ${index + 1}`),
        src: resolveMediaUrl(path),
      };
    })
    .filter(Boolean);

  return {
    label: String(fields.label ?? fallback.label),
    logos: logos.length > 0 ? logos : fallback.logos.map((l) => ({ ...l })),
  };
}

/** Map text-block CTA sections (title, subtitle, button). */
export function mapBookConsultContent(
  section,
  fallback = BOOK_CONSULT_FALLBACK
) {
  const fields = section?.fields ?? {};

  return {
    title: String(fields.title ?? fallback.title),
    subtitle: String(fields.subtitle ?? fallback.subtitle),
    buttonText: String(fields.buttonText ?? fallback.buttonText),
    buttonUrl: String(fields.buttonUrl ?? fallback.buttonUrl),
  };
}

/** Map build-future section → props for About BuildFuture component. */
export function mapBuildFutureContent(
  section,
  fallback = BUILD_FUTURE_FALLBACK
) {
  return mapBookConsultContent(section, fallback);
}

/** Map ready-to-expand section → props for Contact ReadyToExpand component. */
export function mapReadyToExpandContent(
  section,
  fallback = BOOK_CONSULT_FALLBACK
) {
  return mapBookConsultContent(section, fallback);
}

/** Map build-a-connect section → props for Core Models BuildAConnect. */
export function mapBuildAConnectContent(
  section,
  fallback = BUILD_A_CONNECT_FALLBACK
) {
  return mapBookConsultContent(section, fallback);
}

/** Map looking-to-expand section → props for Services LookingToExpand. */
export function mapLookingToExpandContent(
  section,
  fallback = LOOKING_TO_EXPAND_FALLBACK
) {
  return mapBookConsultContent(section, fallback);
}

/** Map lets-build section → props for Projects LetsBuild component. */
export function mapLetsBuildContent(
  section,
  fallback = LETS_BUILD_FALLBACK
) {
  return mapBookConsultContent(section, fallback);
}

/** Map three-layers section → props for Core Models ThreeLayers component. */
export function mapThreeLayersContent(
  section,
  fallback = THREE_LAYERS_FALLBACK
) {
  const fields = section?.fields ?? {};
  const layerImages = pickMediaGroupList(section?.media, 'layers');
  const icons = pickMediaGroupList(section?.media, 'icons');
  const layers = extractThreeLayersFromFields(
    fields,
    layerImages,
    fallback.layers
  );
  const truckPath = icons[0]?.url ?? icons[0]?.Url ?? '';
  const checkPath = icons[1]?.url ?? icons[1]?.Url ?? '';

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    title: String(fields.title ?? fallback.title),
    truckIconUrl: truckPath ? resolveMediaUrl(truckPath) : fallback.truckIconUrl,
    checkIconUrl: checkPath ? resolveMediaUrl(checkPath) : fallback.checkIconUrl,
    layers:
      layers.length > 0
        ? layers
        : fallback.layers.map((layer) => ({ ...layer })),
  };
}

function pickMainSectionImage(media, fallback) {
  const main = pickMediaGroupList(media, 'main');
  if (main[0]) {
    const path = String(main[0].url ?? main[0].Url ?? '').trim();
    return {
      imageUrl: path ? resolveMediaUrl(path) : fallback.imageUrl,
      imageAlt: String(
        main[0].altText ?? main[0].AltText ?? fallback.imageAlt ?? ''
      ),
    };
  }
  const path = pickMediaUrl(media);
  return {
    imageUrl: path ? resolveMediaUrl(path) : fallback.imageUrl,
    imageAlt: pickMediaAlt(media) || fallback.imageAlt,
  };
}

/** Map why-it-matters section → props for WhyItMatters (Core Models & Collaborations). */
export function mapWhyItMattersContent(section) {
  const fields = section?.fields ?? section?.Fields ?? {};
  const media = section?.media ?? section?.Media ?? null;
  const icons = pickMediaGroupList(media, 'icons');
  const checkPath = icons[0]?.url ?? icons[0]?.Url ?? '';

  return {
    eyebrow: String(fields.eyebrow ?? ''),
    title: String(fields.title ?? ''),
    checkIconUrl: checkPath ? resolveMediaUrl(checkPath) : '',
    items: extractWhyItMattersItems(fields),
  };
}

/** Map digital-platform section → props for Core Models DigitalPlatform. */
export function mapDigitalPlatformContent(
  section,
  fallback = DIGITAL_PLATFORM_FALLBACK
) {
  const fields = section?.fields ?? {};
  const backgroundImageUrl = pickBackgroundImageUrl(
    section?.media,
    fallback.backgroundImageUrl
  );
  const logoList = pickMediaGroupList(section?.media, 'logo');
  const logoItem = logoList[0];
  const logoPath = logoItem?.url ?? logoItem?.Url ?? '';

  return {
    eyebrow: String(fields.eyebrow ?? fallback.eyebrow),
    titleLine1: String(fields.titleLine1 ?? fallback.titleLine1),
    titleLine2: String(fields.titleLine2 ?? fallback.titleLine2),
    description: String(fields.description ?? fallback.description),
    backgroundImageUrl,
    logoUrl: logoPath ? resolveMediaUrl(logoPath) : fallback.logoUrl,
    logoAlt: String(
      logoItem?.altText ?? logoItem?.AltText ?? fallback.logoAlt
    ),
  };
}

/** Map eco-system section → props for Core Models EcoSystem component. */
export function mapEcoSystemContent(
  section,
  fallback = ECO_SYSTEM_FALLBACK
) {
  const fields = section?.fields ?? {};
  const { imageUrl, imageAlt } = pickMainSectionImage(
    section?.media,
    fallback
  );

  return {
    title: String(fields.title ?? fallback.title),
    description: String(fields.description ?? fallback.description),
    imageUrl,
    imageAlt,
  };
}

/** Map letters section → props for Core Models Letters component. */
export function mapLettersContent(section, fallback = LETTERS_FALLBACK) {
  const fields = section?.fields ?? {};

  return {
    textHighlight: String(fields.textHighlight ?? fallback.textHighlight),
    textMuted: String(fields.textMuted ?? fallback.textMuted),
  };
}

function extractFooterLinks(fields, prefix, max = 8) {
  const links = [];
  for (let i = 1; i <= max; i += 1) {
    const label = fields[`${prefix}Link${i}Label`];
    const url = fields[`${prefix}Link${i}Url`];
    if (!String(label ?? '').trim()) continue;
    links.push({
      label: String(label).trim(),
      to: String(url ?? '/').trim() || '/',
    });
  }
  return links;
}

function formatCopyright(text, fallback) {
  const year = new Date().getFullYear();
  let s = String(text || fallback).trim();
  if (!s) return `© ${year} Tevris. All rights reserved.`;
  s = s.replace(/\{year\}/gi, String(year));
  if (!/\d{4}/.test(s) && s.startsWith('©')) {
    s = s.replace(/^©\s*/, `© ${year} `);
  }
  return s;
}

function mapFooterSocials(fields, media, fallbackSocials) {
  const icons = pickMediaGroupList(media, 'socials');
  return FOOTER_SOCIAL_META.map((meta, index) => {
    const href = String(fields[meta.field] ?? '').trim() || '#';
    const iconItem = icons[index];
    const iconPath = iconItem?.url ?? iconItem?.Url ?? '';
    const fb = fallbackSocials[index];
    return {
      label: String(iconItem?.altText ?? iconItem?.AltText ?? meta.label),
      href,
      iconUrl: iconPath ? resolveMediaUrl(iconPath) : fb?.iconUrl ?? '',
    };
  });
}

/** Map footer section → props for site Footer (home page CMS). */
export function mapFooterContent(section, fallback = FOOTER_FALLBACK) {
  const fields = section?.fields ?? {};
  const brandList = pickMediaGroupList(section?.media, 'brand');
  const vucaList = pickMediaGroupList(section?.media, 'vuca');
  const brandPath = brandList[0]?.url ?? brandList[0]?.Url ?? '';
  const vucaPath = vucaList[0]?.url ?? vucaList[0]?.Url ?? '';

  const serviceLinks = extractFooterLinks(fields, 'service', 8);
  const companyLinks = extractFooterLinks(fields, 'company', 6);
  const legalLinks = extractFooterLinks(fields, 'legal', 6);

  return {
    brandText: String(fields.brandText ?? fallback.brandText),
    brandLogoUrl: brandPath ? resolveMediaUrl(brandPath) : fallback.brandLogoUrl,
    servicesTitle: String(fields.servicesTitle ?? fallback.servicesTitle),
    companyTitle: String(fields.companyTitle ?? fallback.companyTitle),
    legalTitle: String(fields.legalTitle ?? fallback.legalTitle),
    copyrightText: formatCopyright(
      fields.copyrightText,
      fallback.copyrightText
    ),
    vucaLink: String(fields.vucaLogoUrl ?? fallback.vucaLink).trim() || fallback.vucaLink,
    vucaLogoUrl: vucaPath ? resolveMediaUrl(vucaPath) : fallback.vucaLogoUrl,
    serviceLinks:
      serviceLinks.length > 0 ? serviceLinks : fallback.serviceLinks,
    companyLinks:
      companyLinks.length > 0 ? companyLinks : fallback.companyLinks,
    legalLinks: legalLinks.length > 0 ? legalLinks : fallback.legalLinks,
    socialLinks: mapFooterSocials(fields, section?.media, fallback.socialLinks),
  };
}
